/**
 * `push_to_entity_list` — DEPRECATED but LIVE.
 *
 * Extracted 2026-08-22 from `function-variables-helpers.ts` so that file could be deleted along with
 * the rest of the function-entity subsystem. This block is the one thing in it that was never dead:
 * 225 saved uses across 10 functions in the 2026-06-29 corpus. Un-registering it would make those
 * functions unloadable — a block type that is not registered cannot be LOADED, only silently dropped.
 *
 * Deliberately NOT in the toolbox (hidden 2026-06-28): superseded for new authoring by
 * `push_new_element_to_array`. Registered, loadable, unauthorable — that combination is the point.
 * See docs/archive/stale-blocks/README.md.
 */
import * as Blockly from 'blockly-tradais';
import { javascriptGenerator } from 'blockly-tradais/javascript';
import { AtlasFieldBridge } from './atlas-field-bridge';

export const EntityListPushFns = {
                                  customBlockForPushToEntityList() {
                                    Blockly.Blocks['push_to_entity_list'] = {
                                      init: function () {
                                
                                        this.appendDummyInput('VALUE')
                                        .appendField('push in entity list')
                                        .appendField(
                                          new NonEditableFieldVariable(
                                            'NAN',
                                            undefined,
                                            ['ENTITY_LIST_VARIABLE'],
                                            'ENTITY_LIST_VARIABLE'
                                          ),
                                          'VAR'
                                        );
                              
                                
                                        this.setPreviousStatement(true, null);
                                        this.setNextStatement(true, null);
                                        this.setColour('#800000');
                                        this.setTooltip('Select function variable');
                                        this.setHelpUrl('');
                                      },
                                    };
                                
                                    (javascriptGenerator as any).forBlock['push_to_entity_list'] = function (
                                      block: any
                                    ) { 
                                      var variableName = (javascriptGenerator as any).nameDB_.getName(
                                        block.getFieldValue('VAR'),
                                        'VARIABLE'
                                      );
                              
                                        var value = 'NAN';
                                        var entity = '';
                                        var entityVariable = '';
                                      if(variableName.includes('localVariable') || variableName.includes('globalVariable')) {
                                        variableName = variableName.replace('.data' , '');
                                        entity = variableName.split('$')[0];
                                        if(entity == 'localVariable')
                                        entity = 'local_variable';
                                        else if(entity == 'globalVariable')
                                        entity = 'global_variable';
                                        else
                                        alert('problem in blockly function customBlockForPushToEntityList different entity that localVariable or globalVariable have been selected');
                              
                              
                                        entityVariable = variableName.split('$')[1]; 
                                        if(entity && entity !== '' && entityVariable && entityVariable !== '')
                                        value = ' var returnedData = await this.multiDataManagementService.getVariableByMultiData({ entity:\'' + entity+ '\', entityVariable: \'' + entityVariable+ '\' } , []); if(returnedData.data) { returnedData.pushArray(); } '
                                        else 
                                        value = 'NAN';
                                      } else {
                                        value = 'NAN';
                                      }
                                      
                              
                                          var code = '';
                                    if( value !== 'NAN')
                                      code = value;
                                 
                                      return code;
                                    };
                              
                                    class NonEditableFieldVariable extends Blockly.FieldVariable {
                                      constructor(
                                        variableName: any,
                                        validator: any,
                                        variableTypes: any,
                                        defaultType: any
                                      ) {
                                        super(variableName, validator, variableTypes, defaultType);
                                      }
                                
                                      // Override the showEditor_ method to disable editing
                                      override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                                    }
  },
};
